export default __webpack_public_path__ + "fa5d247445c653625c639cdcf93f1c36.jpeg";